import { Container } from '@eliadmin/core/src/components/ui/container';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useConfiguratorStore } from '@eliadmin/core/src/stores/configurator-store';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { formatPrice } from '@eliadmin/core/src/utils/price-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useQuery } from '@tanstack/react-query';
import Link from '@eliadmin/core/src/components/link';
import { RiCloseFill, RiShoppingBasketLine } from 'react-icons/ri';

export function ConfiguratorNavigation() {
  const me = useCustomerStore(s => s.me);
  const cart = useQuery({ ...useCartQueryOpts(), enabled: !!me?.authToken });
  const { t } = useTranslations();
  const returnPath = useConfiguratorStore(s => s.returnPath);

  const currencySettings = useGlobalStore(s => s.generalLayout.currency_settings);
  const currency = useGlobalStore(s => s.generalLayout.currency);

  return (
    <nav className="w-full border-b border-t-[4px] border-b-muted border-t-accent px-0 py-2 md:px-4 md:py-4">
      <Container className="flex w-full max-w-[1600px] items-center justify-between">
        <Link href={returnPath} replace className="flex items-center gap-2.5 text-accent">
          <RiCloseFill size={20} />
          <p className="hidden md:block">{t('text1467')}</p>
        </Link>

        <h1 className="text-2xl font-semibold text-[#333333] md:text-3xl">Smako Konfigurátor</h1>

        <Link
          href={ROUTES.CART()}
          className={cn(
            'flex items-center justify-end gap-2 transition hover:opacity-80',
            'ea-header-main__cart',
          )}
        >
          <p className="hidden text-sm font-medium text-[#0D0C22] md:block">
            {formatPrice(cart.data?.items_total_without_vat ?? 0, currency, currencySettings)}
          </p>
          {/* <ShoppingCart /> */}
          <div className="relative flex h-12 w-12 items-center justify-center rounded-full bg-accent-foreground">
            <p className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-accent p-0.5">
              <span className="text-[10px] text-secondary">{cart.data?.count ?? 0}</span>
            </p>
            <RiShoppingBasketLine className="h-6 w-6 text-accent" size={24} />
          </div>
        </Link>
      </Container>
    </nav>
  );
}
